import { getApiEndpoint } from './apiConfig';

class ConfigService {
  constructor() {
    this.config = null;
    this.configPromise = null;
  }

  /**
   * Fetch configuration from backend
   * Uses caching to avoid multiple requests
   */
  async getConfig() {
    // If we already have config, return it
    if (this.config) {
      return this.config;
    }

    // If a request is already in progress, return the same promise
    if (this.configPromise) {
      return this.configPromise;
    }

    // Make the request and cache the promise
    this.configPromise = this.fetchConfigFromServer();
    
    try {
      this.config = await this.configPromise;
      return this.config;
    } catch (error) {
      // Reset promise on error so we can retry
      this.configPromise = null;
      throw error;
    }
  }

  async fetchConfigFromServer() {
    try {
      const response = await fetch(getApiEndpoint('config/frontend'), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch config: ${response.status}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch configuration');
      }

      return result.data;
    } catch (error) {
      console.error('Error fetching config:', error);
      
      // Fallback to hardcoded values if server is not available
      // This ensures the app still works during development or if there are connectivity issues
      const fallbackConfig = {
        googleClientId: "821655551237-l5ofs6ev0q4sh32hcgvt72bch3v1mhme.apps.googleusercontent.com",
        environment: "development",
        baseUrl: window.location.origin
      };

      console.warn('Using fallback configuration due to server error:', error.message);
      return fallbackConfig;
    }
  }

  /**
   * Get Google Client ID specifically
   */
  async getGoogleClientId() {
    const config = await this.getConfig();
    return config.googleClientId;
  }

  /**
   * Clear cached config (useful for testing or if config changes)
   */
  clearCache() {
    this.config = null;
    this.configPromise = null;
  }
}

// Export a singleton instance
const configService = new ConfigService();
export default configService;
